import { Flag } from "lucide-react";
import MultiSelector from "./MultiSelector";
import { GRADE_STATUSES } from "../../../config/settings.config";
import { useSettings } from "../../../context/SettingsContext";
import { useState } from "react";

export default function SettingsGrade() {
  const { grade_status, saveGrade } = useSettings();
  const [saving, setSaving] = useState(false);

  const onSave = async (next) => {
    try {
      setSaving(true);
      await saveGrade(next);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <MultiSelector
        title="Grade Status"
        icon={Flag}
        allItems={GRADE_STATUSES}
        selected={grade_status}
        setSelected={onSave}
        saving={saving}
      />
    </>
  );
}
